import { CancelToken } from 'axios'

import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils/axios'

import { BiohazardousManifest } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<BiohazardousManifest.Basic>> =>
	Http.get(baseUrl, { params })

export const searchSuggestions = (
	params: TableUrlParams,
	cancelToken?: CancelToken
): Promise<BiohazardousManifest.Search.Result> =>
	Http.get(`${baseUrl}/search-suggestions`, { params, cancelToken })

export const downloadDoc = (docId: Key): Promise<Blob> =>
	Http.get(`${baseUrl}/documents/${docId}/download`, {
		responseType: 'blob'
	})
